import styled, {css} from "styled-components";
import {switchProp} from "styled-tools";
import {motion} from "motion/react"
import {getColorFromTheme} from "../../utils/style.utils";
import {OptionWrapperStyleProps, selectTriggerStyleProps} from "./select.type";

export const Wrapper = styled.div<selectTriggerStyleProps>`
    min-width: 200px;
    position: relative;
    ${(props) => css`
        .select-btn {
            background-color: var(--color-secondary-dark);
            color: var(--color-accent);
            border: 1px solid color-mix(in srgb, var(--color-border) 60%, transparent);
            justify-content: space-between;
            [data-theme="dark"] & {
                --color-secondary-dark: transparent;
                --color-accent: #FFFFFF;
            }
            ${switchProp("$size", {
                "md": css`
                    padding: 10px 18px;
                    font-size: calc(var(--step-0) * 0.69);
                `,
                "lg": css`
                    padding: 12px 20px;
                    font-size: calc(var(--step-0) * 0.9);
                `,
            }, css`
                padding: 10px 18px;
                font-size: calc(var(--step-0) * 0.69);
            `)}
            &:focus-within {
                border-color: var(--color-text-dark);
            }
        }

        ${({theme}: { theme: any, }) => theme.breakpoints.down("md")} {
            > .select-btn {
                font-size: 14px;
                padding: 15px 10px
            }
        }
    `}
`
export const OptionWrapperStyle = styled(motion.div)<OptionWrapperStyleProps>`
    background-color: var(--color-secondary-light);
    //padding: .75rem 0;
    max-height: 19rem;
    border-radius: 12px;
    user-select: none;
    z-index: 50;
    will-change: transform;
    position: absolute;

    .rb-option-icon {
        margin-inline-end: 8px;
    }

    ul {
        padding: .75rem;
        overflow-y: scroll;
        scrollbar-width: thin;
        scrollbar-color: transparent transparent;
    }

    div::-webkit-scrollbar,
    ul::-webkit-scrollbar {
        width: 6px;
    }

    .label {
        padding: 1rem 1.25rem;
        border-bottom: 1px solid color-mix(in srgb, var(--color-border) 60%, transparent);
        z-index: 10;
        position: sticky;
        top: 0;
        background-color: var(--color-secondary-light);
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        align-items: center;

        button.close-btn {
            display: none;
            border-radius: 0.75rem;
            background-color: rgb(245 245 245);
            border-color: transparent;

            &:hover {
                background: ${getColorFromTheme("neutral50")};
            }
        }

        b {
            font-size: var(--step--1);
            color: var(--color-text-dark);
            font-weight: 700;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("sm")} {
        .label {
            button.close-btn {
                display: inline-flex;
            }

            b {
                font-weight: 500 !important;
                font-family: Inter, sans-serif;
            }
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        ul {
            padding: 0rem;
        }
    }

`
export const OptionStyle = styled.li`
    display: flex;
    font-size: 15px;
    align-items: center;
    align-self: center;
    justify-content: space-between;
    font-weight: 500;
    color: #1D2739;
    padding: .75rem .5rem;
    cursor: pointer;
    max-height: 80px;

    & * {
        font-size: inherit;
    }

    .rb-option-label {
        text-transform: capitalize;
        margin-right: auto;
    }

    &[data-selected="true"] {
        .radio-input {
            border-color: #3900BD;
            border-width: 0px;;
            background-color: #3900BD;
        }
    }

    .radio-input {
        display: block !important;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 16px;
        height: 16px;
        border: 1px solid #3900BD;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        background-color: #F1ECFD;
        overflow: hidden;
        border-spacing: 0px;
        -webkit-border-horizontal-spacing: 0px;
        -webkit-border-vertical-spacing: 0px;
        padding: 0;
        cursor: inherit;
    }

    &:focus, &:focus-visible, &:hover {
        border-radius: 9px;
        background: var(--color-secondary-hover);
    }

    &:not(:last-child) {
        border-bottom: 1px solid color-mix(in srgb, var(--color-border) 60%, transparent);
    }

    &:first-child {
        label {
            //padding-top: 0;
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        border-color: transparent !important;
    }
`